import { Injectable, Signal } from '@angular/core';
import { IRefusedData, IRefusedModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IRefusedState, RefusedActions, RefusedSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class RefusedStore extends StateAccessService<IRefusedState> {
  readonly state$: Observable<IRefusedState>;

  readonly data$$: Signal<IRefusedData>;
  readonly model$$: Signal<IRefusedModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(RefusedSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(RefusedSelectors.data);
  }

  dispatchRefusedReset() {
    this.stateFacade.dispatch(RefusedActions.reset());
  }
  dispatchRefusedLoad() {
    this.stateFacade.dispatch(RefusedActions.load());
  }
  dispatchRefusedLoadSuccess({ model, data }: { model: IRefusedModel; data: IRefusedData }) {
    this.stateFacade.dispatch(RefusedActions.loadSuccess({ model, data }));
  }
  dispatchRefusedSubmit() {
    this.stateFacade.dispatch(RefusedActions.submit());
  }
  dispatchRefusedSubmitSuccess({ model, data }: { model: IRefusedModel; data: IRefusedData }) {
    this.stateFacade.dispatch(RefusedActions.submitSuccess({ model, data }));
  }
}
